import React, { forwardRef } from "react";
import { useSnackbar } from "notistack";
// hooks
import { useAuthContext } from "src/auth/hooks";
import { useCountdownSeconds } from "src/hooks/use-countdown";
// components
import Banner from "src/components/template/banner";

// ----------------------------------------------------------------------

// eslint-disable-next-line no-empty-pattern
const BannerVerify = forwardRef(({}, ref) => {
    const { enqueueSnackbar } = useSnackbar();

    const { user, resendActivateEmail } = useAuthContext();

    const { counting, countdown, startCountdown } = useCountdownSeconds(60);

    const handleResendEmail = async () => {
        try {
            if (user?.email) {
                const response = await resendActivateEmail(user.email);

                if (response) {
                    enqueueSnackbar("Email Sent", { variant: "success" });
                }
            }
        } catch (error) {
            console.error(error);
            //
            enqueueSnackbar(error?.msg, { variant: "error" }); // Optional: Show error snackbar if API call fails
        }
    };

    // ----------------------------------

    return (
        <Banner
            ref={ ref } variant="info"
            content="Please verify your email address first to generate API keys."
            buttonText={ counting ? `Try again in ${ countdown }s` : "Resend Verification Link" }
            ButtonProps={ {
                onClick: () => handleResendEmail().finally(() => startCountdown()),
                sx: {
                    width: "150px",
                    height: "30px",
                    px: 0,
                    "&.MuiButton-outlined": {
                        borderColor: "white !important",
                        backgroundColor: "transparent  !important",
                        "&:hover": {
                            backgroundColor: "transparent !important"
                        }
                    }
                },
                disabled: counting
            } }
        />
    );
});

export default BannerVerify;
